"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RemoveUnusedComponents = void 0;

var utils_1 = require("../../utils");

var RemoveUnusedComponents = function RemoveUnusedComponents() {
  var components = new Map();

  function registerComponent(location, componentType, name) {
    var _a;

    components.set(location.absolutePointer, {
      used: ((_a = components.get(location.absolutePointer)) === null || _a === void 0 ? void 0 : _a.used) || false,
      componentType: componentType,
      name: name
    });
  }

  return {
    ref: {
      leave: function leave(ref, _ref) {
        var type = _ref.type,
            resolve = _ref.resolve,
            key = _ref.key;

        if (['Schema', 'Header', 'Parameter', 'Response', 'Example', 'RequestBody'].includes(type.name)) {
          var resolvedRef = resolve(ref);
          if (!resolvedRef.location) return;
          components.set(resolvedRef.location.absolutePointer, {
            used: true,
            name: key.toString()
          });
        }
      }
    },
    Root: {
      leave: function leave(root, ctx) {
        var data = ctx.getVisitorData();
        data.removedCount = 0;
        components.forEach(function (usageInfo) {
          var used = usageInfo.used,
              componentType = usageInfo.componentType,
              name = usageInfo.name;

          if (!used && componentType && root.components) {
            var componentChild = root.components[componentType];
            delete componentChild[name];
            data.removedCount++;

            if (utils_1.isEmptyObject(componentChild)) {
              delete root.components[componentType];
            }
          }
        });

        if (utils_1.isEmptyObject(root.components)) {
          delete root.components;
        }
      }
    },
    NamedSchemas: {
      Schema: function Schema(schema, _ref2) {
        var location = _ref2.location,
            key = _ref2.key;

        if (!schema.allOf) {
          registerComponent(location, 'schemas', key.toString());
        }
      }
    },
    NamedParameters: {
      Parameter: function Parameter(_parameter, _ref3) {
        var location = _ref3.location,
            key = _ref3.key;
        registerComponent(location, 'parameters', key.toString());
      }
    },
    NamedResponses: {
      Response: function Response(_response, _ref4) {
        var location = _ref4.location,
            key = _ref4.key;
        registerComponent(location, 'responses', key.toString());
      }
    },
    NamedExamples: {
      Example: function Example(_example, _ref5) {
        var location = _ref5.location,
            key = _ref5.key;
        registerComponent(location, 'examples', key.toString());
      }
    },
    NamedRequestBodies: {
      RequestBody: function RequestBody(_requestBody, _ref6) {
        var location = _ref6.location,
            key = _ref6.key;
        registerComponent(location, 'requestBodies', key.toString());
      }
    },
    NamedHeaders: {
      Header: function Header(_header, _ref7) {
        var location = _ref7.location,
            key = _ref7.key;
        registerComponent(location, 'headers', key.toString());
      }
    }
  };
};

exports.RemoveUnusedComponents = RemoveUnusedComponents;